import React, {FC, ReactElement} from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Link from '@material-ui/core/Link';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import {Grid, makeStyles} from '@material-ui/core';
import {useSearchContext} from '@context';
import {strings} from '@constants';
import IconText from '../icon-text/IconText';
import {SourceType} from '@types';
import SourceLabel from '../source-label/SourceLabel';

const useStyles = makeStyles(theme => ({
    root: {
        padding: 0
    },
    item: {
        padding: 0,
        marginBottom: theme.spacing(3.5)
    },
    title: {
        display: 'inline-block',
        marginBottom: theme.spacing(1),
        color: theme.palette.text.link,
        fontSize: theme.typography.pxToRem(22)
    },
    text: {
        display: 'block',
        marginBottom: theme.spacing(1),
    },
    source: {
        [theme.breakpoints.down('sm')]: {
            marginBottom: theme.spacing(1)
        }
    },
    extraData: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingLeft: theme.spacing(4),
        '& > *:not(:last-child)': {
            marginBottom: theme.spacing(1)
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
        }
    }
}));

const SearchResultsList: FC = (): ReactElement => {
    const classes = useStyles();
    const {result} = useSearchContext();

    return (
        <List className={classes.root}>
            {result.records.map(({id, title, source, text, url, likes, views, updatedAt}) => (
                <ListItem
                    key={id}
                    className={classes.item}>
                    <ListItemText
                        primary={
                            <>
                                <Grid container>
                                    <Grid item md={10}>
                                        <Link
                                            className={classes.title}
                                            href={url}
                                            target="_blank"
                                            variant="h6">
                                            {title}
                                        </Link>
                                        <Typography
                                            component="span"
                                            className={classes.text}
                                            color="textPrimary">
                                            {text}
                                        </Typography>
                                        <SourceLabel
                                            className={classes.source}
                                            source={source}/>
                                    </Grid>
                                    <Grid item md={2} className={classes.extraData}>
                                        <IconText
                                            icon="crowd"
                                            text={strings.views(views)}
                                            show={source === SourceType.enum.COMMUNITY}/>
                                        <IconText
                                            icon="calendar"
                                            text={updatedAt}/>
                                        <IconText
                                            icon="like"
                                            text={strings.likes(likes)}
                                            show={source === SourceType.enum.COMMUNITY}
                                            halfLineHeight={true}/>
                                    </Grid>
                                </Grid>
                            </>

                        }/>
                </ListItem>
            ))}
        </List>
    );
};

export default SearchResultsList;
